import merge from 'deepmerge';
import dotProp from 'dot-prop-immutable';
import * as R from 'ramda';
import { setConfig } from './config';
export default (clientId, config, _context = window) => {
    const initialConfig = merge.all([
        {
            clientId,
            // @ts-expect-error: these props do exist
            context: R.pick(['gtag', 'dataLayer'], _context)
        },
        dotProp.get(config, 'common', {}),
        dotProp.get(config, `apps.${clientId}.config`, {})
    ]);
    setConfig(initialConfig);
};
